import { Dictionary } from '../data-structures';

export function listToDictionary<T>(list: T[], attribute: keyof T): { [key in string | number]: T } {
  const dictionary = {};
  for (const element of list) {
    dictionary[element[attribute.toString()]] = element;
  }
  return dictionary;
}

export function listToDictionaryWithMultipleAttributes<T>(list: T[], attributes: string[]): Dictionary<string | number> {
  const dictionary = {};

  for (const element of list) {
    const key = attributes.map((attribute) => element[attribute]).join('_');
    dictionary[key] = element;
  }
  return dictionary;
}
